/* Vexira motion script. The look-and-feel code of the site: header over the film, front film with the cut-out logo, Garden Hours film, shop-by-category strips,
   Slow afternoons scene, letters that close up, photo drift, cards that open like a curtain, product-card photo flip, smooth scroll (GSAP + ScrollTrigger + Lenis).
   Nothing here touches the bag, product page or forms (see vexira.js). Nothing runs with reduced motion or if the libraries did not load.
   Generated from the mock site's app.js: change the mock, then rebuild. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  root.classList.add('js');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || doc).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- home film: landscape on large screens, vertical on phones ---------- */
  var hero = $('.hero[data-hero]'), film = hero && $('#film', hero), film2 = hero && $('#film2', hero);   /* film2 is the same film seen through the logo cut-out (see .hero-mask) */
  var film2On = false;
  /* film2 only runs once the page has moved: at the very top it is hidden and paused, so two separate copies of the film can never show up as a ghost of the logo.
     It is lined up with the main film at the moment it starts. */
  function film2Go(on) {
    if (!film2 || on === film2On) return;
    film2On = on;
    if (on) { try { film2.currentTime = film.currentTime; } catch (e) {} var p = film2.play(); if (p && p.catch) p.catch(function () {}); }
    else film2.pause();
  }
  function pickFilm() {
    if (!film) return;
    var portrait = innerWidth < 900 || innerHeight > innerWidth * 1.05;
    var lite = (navigator.connection && navigator.connection.saveData) || innerWidth < 1400;
    var d = hero.dataset;
    var src = portrait ? d.srcPort : (lite ? d.srcLandSmall : d.srcLand);
    if (!src) return;
    if (film.getAttribute('data-src') === src) return;
    film.setAttribute('data-src', src);
    film.poster = (portrait ? d.posterPort : d.posterLand) || '';
    film.style.objectPosition = portrait ? '50% 50%' : '50% 40%';
    film.src = src;
    film.muted = true; film.defaultMuted = true;
    if (film2 && !reduce) { film2.poster = film.poster; film2.style.objectPosition = film.style.objectPosition; film2.src = src; film2.muted = true; film2.defaultMuted = true; }
    if (!reduce) { var p = film.play(); if (p && p.catch) p.catch(function () {}); if (film2On) { var p2 = film2.play(); if (p2 && p2.catch) p2.catch(function () {}); } }
  }
  if (film) {
    pickFilm();
    var rt; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(pickFilm, 200); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!reduce && film.paused) { var p = film.play(); if (p && p.catch) p.catch(function () {}); if (film2On) { var p2 = film2.play(); if (p2 && p2.catch) p2.catch(function () {}); } } }
          else if (!film.paused) { film.pause(); if (film2) film2.pause(); }
        });
      }, { threshold: 0.1 }).observe(hero);
    }
    if (film2 && !reduce) setInterval(function () { if (film2On && !film.paused && film.readyState > 2 && Math.abs(film2.currentTime - film.currentTime) > 0.08) film2.currentTime = film.currentTime; }, 1000);   /* keep the two copies in step */
  }

  /* ---------- header: clear over a full-bleed picture, white after; hides going down, returns going up ---------- */
  var hdr = $('#hdr'), last = 0, tick = false;
  var clearHead = doc.body.classList.contains('home');   /* clear over the film at the top, mint bar once the page moves */
  function head() {
    tick = false;
    var y = scrollY, open = hdr.classList.contains('open');
    hdr.classList.toggle('solid', !clearHead || y > 10);
    if (!open) {   /* hides while scrolling down, comes back as soon as you scroll up (the docked home logo follows it, see below) */
      var floor = clearHead ? 120 : 200;
      if (y > last && y > floor) hdr.classList.add('hide');
      else if (y < last || y <= floor) hdr.classList.remove('hide');
    }
    last = y;
  }
  if (hdr) {
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(head); } }, { passive: true });
    head();
  }

  /* ---------- product cards: move the mouse across a photo to flip through its pictures (mouse only) ---------- */
  if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
    var flip = function (card, i) {
      var imgs = card._imgs || (card._imgs = $$('.pc-img img', card));
      if (imgs.length < 2) return;
      i = Math.max(0, Math.min(imgs.length - 1, i));
      if (card._i === i) return;
      card._i = i;
      var bars = card._bars || (card._bars = $$('.pc-bars i', card));
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === i); });
      bars.forEach(function (b, k) { b.classList.toggle('on', k === i); });
    };
    doc.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !e.target.closest) return;
      var card = e.target.closest('.pc');
      if (!card) return;
      var r = card.getBoundingClientRect(), n = (card._imgs || (card._imgs = $$('.pc-img img', card))).length;
      flip(card, Math.floor((e.clientX - r.left) / r.width * n));
    }, { passive: true });
    doc.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('.pc');
      if (card && !card.contains(e.relatedTarget)) flip(card, 0);
    });
  }

  /* ---------- scroll-linked photo motion: photos drift slower than the page, and settle in from a slight zoom ---------- */
  var mo = [];
  /* switched off on purpose: the drift and the settle-in zoom scaled the photos by 1.1x-1.2x and slid them, which cut the top of the models' faces.
     To bring it back for a picture with no faces, list it here as [selector, zoom]. */
  [].forEach(function (g) {
    $$(g[0]).forEach(function (img) { mo.push({ img: img, box: img.parentElement, zoom: g[1] }); });
  });
  var mTick = false;
  function motion() {
    mTick = false;
    var vh = innerHeight;
    for (var i = 0; i < mo.length; i++) {
      var m = mo[i], r = m.box.getBoundingClientRect();
      if (r.bottom < -60 || r.top > vh + 60) continue;
      var p = (vh - r.top) / (vh + r.height);              /* 0 as the box enters at the bottom, 1 as it leaves at the top */
      var ty = (p - 0.5) * 2 * r.height * 0.045;
      var s = 1.1;
      if (m.zoom) { var q = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.62))); s = 1.1 + 0.1 * (1 - (1 - (1 - q) * (1 - q))); }
      m.img.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ')';
    }
  }
  if (mo.length && !reduce) {
    addEventListener('scroll', function () { if (!mTick) { mTick = true; requestAnimationFrame(motion); } }, { passive: true });
    addEventListener('resize', motion);
    motion();
  }

  /* ---------- cards open like a curtain, top to bottom, one column after the other, tied to the scroll (as on the reference site) ----------
     New in (the rail) and every product / feed grid. The cards stay top-aligned and their bottom edge drops while the row comes up the screen:
     at any moment the first column is further open than the second, and so on. The photo settles from a slight zoom as it opens. */
  var cuSets = [], cuTick = false;
  var niRail = $('.newin [data-rail], .newin .rail');
  if (niRail) cuSets.push({ box: niRail, cards: $$('.pc', niRail), rail: true });
  /* the "More to love" rails (product page, size guide) open the same way as New in on the home page */
  $$('.more .rail').forEach(function (r) { cuSets.push({ box: r, cards: $$('.pc', r), rail: true }); });
  $$('.cgrid, .fd-grid').forEach(function (g) { cuSets.push({ box: g, cards: [].slice.call(g.children).filter(function (c) { return c.matches('.pc, .fd'); }), rail: false }); });
  /* Measured on the reference (dropedition.com): it is not tied to the scroll. When a row of cards comes up past about 80% of the screen a white cover
     over each card shrinks from the bottom to the top, one column after the other (left to right), the photo settles from a 1.2 zoom, and it stays open. */
  function cuRun() {
    cuTick = false;
    var vh = innerHeight;
    cuSets.forEach(function (set) {
      var bl = set.rail ? 0 : set.box.getBoundingClientRect().left;
      set.cards.forEach(function (c, i) {
        if (c.__cu === 2) return;
        var r = c.getBoundingClientRect();
        if (r.top > vh * 0.82) return;
        var col = set.rail ? i : Math.round((r.left - bl) / Math.max(1, r.width));
        c.style.setProperty('--cd', (Math.min(col, 4) * 0.24).toFixed(2) + 's');
        c.classList.add('cu-in'); c.__cu = 2;
      });
    });
  }
  if (cuSets.some(function (s) { return s.cards.length; }) && !reduce) {
    cuSets.forEach(function (set) { set.cards.forEach(function (c) { c.classList.add('cu'); }); });
    addEventListener('scroll', function () { if (!cuTick) { cuTick = true; requestAnimationFrame(cuRun); } }, { passive: true });
    addEventListener('resize', cuRun);
    addEventListener('load', cuRun);
    requestAnimationFrame(function () { requestAnimationFrame(cuRun); });
  }

  /* ---------- text whose letters close up when it comes into view ---------- */
  function hash(n) { var x = Math.sin(n * 12.9898 + 78.233) * 43758.5453; return x - Math.floor(x); }
  var tight = $$('[data-tight]'), cn = 0;
  tight.forEach(function (el) {
    var label = el.innerHTML.replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
    var lines = el.innerHTML.split(/<br\s*\/?>/i);
    el.setAttribute('aria-label', label);
    el.innerHTML = lines.map(function (l) {
      return '<span class="ln" aria-hidden="true">' + l.replace(/<[^>]*>/g, '').trim().split(/\s+/).map(function (w) {
        return '<span class="wd">' + w.split('').map(function (c) {
          cn++;
          return '<span class="ch" style="--x:' + (hash(cn) * 0.8).toFixed(2) + ';--d:' + ((cn % 9) * 45) + 'ms">' + esc(c) + '</span>';
        }).join('') + '</span>';
      }).join(' ') + '</span>';
    }).join('');
  });
  /* data-scrub text is driven by scroll instead (see slow afternoons), so it never gets the one-time .go */
  var tightGo = tight.filter(function (el) { return !el.hasAttribute('data-scrub'); });
  if (tightGo.length) {
    if ('IntersectionObserver' in window && !reduce) {
      var tio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('go'); tio.unobserve(e.target); } }); }, { threshold: 0.3 });
      tightGo.forEach(function (el) { tio.observe(el); });
    } else tightGo.forEach(function (el) { el.classList.add('go'); });
  }

  /* ---------- shop by category strips: hover or focus opens one; on touch the first tap opens, the second follows the link ---------- */
  $$('[data-acc]').forEach(function (acc) {
    var strips = [].slice.call(acc.children);
    function openStrip(s) { strips.forEach(function (x) { x.classList.toggle('open', x === s); }); }
    strips.forEach(function (s) {
      s.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') openStrip(s); });
      s.addEventListener('focus', function () { openStrip(s); });
      s.addEventListener('click', function (e) { if (!s.classList.contains('open')) { e.preventDefault(); openStrip(s); } });
    });
  });

  /* ---------- slow afternoons: everything follows the scroll, both ways, so it replays every time.
     enter  (section rising into view): the frame zooms in
     pinned (section held on screen):  the frame opens to full bleed, the caption arrives
     the whole way (enter + pinned): the letter spacing of the big text keeps opening ---------- */
  var sa = $('.sa');
  if (sa && !reduce) {
    sa.classList.add('sa-anim');
    var saE = 0, saT = 0, saG = 0, saTE = 0, saTT = 0, saTG = 0, saRun = false;
    var saClamp = function (v) { return Math.min(1, Math.max(0, v)); };
    var saSeg = function (t, a, b) { return saClamp((t - a) / (b - a)); };
    var saCalc = function () {
      var r = sa.getBoundingClientRect(), span = r.height - innerHeight;
      saTE = saClamp(1 - r.top / innerHeight);
      saTT = span > 0 ? saClamp(-r.top / span) * 1.15 : 0;
      saTG = saClamp((innerHeight - r.top) / (innerHeight + Math.max(span, 0)));   /* 0 as the section enters, 1 at the end of the pin */
    };
    var saDraw = function () {
      var e = saE, t = saT, o = saSeg(t, 0, 1), c = saSeg(t, 0.72, 1.02), c2 = saSeg(t, 0.8, 1.09), c3 = saSeg(t, 0.88, 1.15), st = sa.style;
      st.setProperty('--fs', (0.78 + 0.22 * e).toFixed(3));
      st.setProperty('--cy', (25 * (1 - o)).toFixed(2) + '%');
      st.setProperty('--cx', (33 * (1 - o)).toFixed(2) + '%');
      st.setProperty('--is', (1.12 - 0.12 * o).toFixed(3));   /* a gentle settle: 1.35 used to push the face out of the frame */
      st.setProperty('--g', saG.toFixed(4));      st.setProperty('--co', c.toFixed(3));
      st.setProperty('--cty', (40 * (1 - c)).toFixed(1) + 'px');
      st.setProperty('--co2', c2.toFixed(3));
      st.setProperty('--cty2', (40 * (1 - c2)).toFixed(1) + 'px');
      st.setProperty('--co3', c3.toFixed(3));
      st.setProperty('--cty3', (40 * (1 - c3)).toFixed(1) + 'px');
    };
    /* ease towards the scroll position so the zoom and the letter spacing glide instead of jumping */
    var saStep = function () {
      saRun = false;
      var de = saTE - saE, dt = saTT - saT, dg = saTG - saG;
      if (Math.abs(de) < 0.0006 && Math.abs(dt) < 0.0006 && Math.abs(dg) < 0.0006) { saE = saTE; saT = saTT; saG = saTG; saDraw(); return; }
      saE += de * 0.16; saT += dt * 0.16; saG += dg * 0.16; saDraw();
      saRun = true; requestAnimationFrame(saStep);
    };
    var saKick = function () { saCalc(); if (!saRun) { saRun = true; requestAnimationFrame(saStep); } };
    addEventListener('scroll', saKick, { passive: true });
    /* phones and tablets: the photo stops opening above the text, so the text sits on the cream, not over the busy print, and the face
       stays clear (client, 29 Oct). --sb is the height kept free at the bottom: from the top of the paragraph down, plus a gap. */
    var saBand = function () {
      if (innerWidth >= 900) { sa.style.removeProperty('--sb'); return; }
      var pin = $('.sa-pin', sa), p = $('.sa-bg .stmt-s', sa);
      if (!pin || !p) return;
      sa.style.setProperty('--sb', Math.ceil(pin.getBoundingClientRect().bottom - p.getBoundingClientRect().top + 28) + 'px');
    };
    addEventListener('resize', function () { saBand(); saCalc(); saE = saTE; saT = saTT; saG = saTG; saDraw(); });
    saBand(); if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(saBand);
    saCalc(); saE = saTE; saT = saTT; saG = saTG; saDraw();
  }

  /* ---------- editorial film: loads when it is near the screen, plays while it is on screen, landscape on large screens and vertical on phones ---------- */
  $$('.ed-film').forEach(function (v) {
    var port = innerWidth < 900 || innerHeight > innerWidth * 1.05;
    v.poster = (port ? v.getAttribute('data-poster-port') : v.getAttribute('data-poster-land')) || '';
    v.style.objectPosition = port ? '50% 50%' : '50% 40%';
    if (reduce || !('IntersectionObserver' in window)) return;
    var loaded = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          if (!loaded) { loaded = true; v.src = port ? v.getAttribute('data-port') : (innerWidth >= 1400 && v.getAttribute('data-land-hd') ? v.getAttribute('data-land-hd') : v.getAttribute('data-land')); v.muted = true; v.defaultMuted = true; }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (loaded && !v.paused) v.pause();
      });
    }, { rootMargin: '300px 0px', threshold: 0.01 }).observe(v);
  });

  /* ---------- front film: as the page scrolls a pale veil settles over the picture and the word Vexira, cut out of it, opens up (see .hero-veil) ---------- */
  var heroEl = $('.hero'), heroRunEl = $('.hero-run');
  if (heroEl && $('.hero-veil', heroEl) && !reduce) {
    heroEl.classList.add('hero-anim');
    if (heroRunEl) heroRunEl.classList.add('run');   /* the film stays pinned while the page scrolls through the runway */
    var hpC = 0, hpT = 0, hpRun = false;
    var hpSet = function () {
      var e = 1 - Math.pow(1 - Math.min(1, hpC), 2), phone = innerWidth < 900, st = heroEl.style;   /* power2.out, as on the reference */
      var x = Math.min(1, Math.max(0, hpC - 1));                                           /* second screen of scrolling: the pinned film is squeezed away */
      st.setProperty('--hh', (innerHeight * Math.pow(1 - x, 2)).toFixed(1) + 'px');       /* its height 100% -> 0, ease power2.out, content stays put and is clipped */
      st.setProperty('--hp', hpC.toFixed(4));
      st.setProperty('--hm', Math.min(1, hpC * 10).toFixed(3));                            /* the logo cut-out fades in over the first tenth of a screen: nothing shows at rest */
      film2Go(hpC > 0.004);
      st.setProperty('--ho', (0.8 * e).toFixed(4));                                       /* veil opacity 0 -> .8 */
      st.setProperty('--hs', ((phone ? 80 : 66) + (phone ? 12 : 18) * e).toFixed(2));     /* logo width 66% -> 84% of the screen (80% -> 92% on a phone): it grows, but always stays whole and centred */
      st.setProperty('--hy', (0.2 * innerHeight * e).toFixed(1) + 'px');                   /* the picture inside the logo slides down by 20% of the screen */
    };
    var hpCalc = function () {
      var r = (heroRunEl || heroEl).getBoundingClientRect();
      hpT = Math.min(2, Math.max(0, -r.top / innerHeight));   /* 0-1: veil, logo and slide play. 1-2: the film is squeezed away */
    };
    var hpStep = function () {
      hpRun = false;
      var d = hpT - hpC;
      if (Math.abs(d) < 0.0006) { hpC = hpT; hpSet(); return; }
      hpC += d * (window.vxLenis ? 0.4 : 0.14); hpSet();   /* Lenis already glides the scroll itself */ hpRun = true; requestAnimationFrame(hpStep);
    };
    addEventListener('scroll', function () { hpCalc(); if (!hpRun) { hpRun = true; requestAnimationFrame(hpStep); } }, { passive: true });
    addEventListener('resize', function () { hpCalc(); hpC = hpT; hpSet(); });
    hpCalc(); hpC = hpT; hpSet();
  }

  /* ---------- quiet reveals ---------- */
  var rv = $$('.ni-head, .ni-ctl, .ed-big, .ed-small, .ed-copy, .fd-head, .ft-in, .jf, .jc, .al, .ap, .at, .aq, .ab-row, .ab-two>div, .more, .sets .sec-head, .cat-head, .acc');
  rv.forEach(function (e) { e.classList.add('rv'); });
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    rv.forEach(function (e, i) { e.style.transitionDelay = ((i % 3) * 90) + 'ms'; io.observe(e); });
  } else rv.forEach(function (e) { e.classList.add('in'); });

  /* ---------- cards: they slide up slowly from below, one after the other, as they scroll into view ---------- */
  /* same reveal for the photos of the inner pages (owner, 3 Nov: as on the home page): about, journal, size guide, shipping, and the product
     gallery on large screens only (on phones it is a sideways slider, where a photo sliding up as you swipe would look wrong) */
  var rc = $$('.tile, .stl, .ab-mos figure, .ab-two figure, .ab-full, .al figure, .ap figure, .jf-img, .jf-s, .jc > a, .sg-img, .lp-fig' + (matchMedia('(min-width: 900px)').matches ? ', .pdp-g figure' : ''));
  rc.forEach(function (e) { e.classList.add('rv-card'); });
  /* the closed curtain clips the whole box, so an IntersectionObserver sees nothing of it and would never fire: like the home page cards,
     measure the boxes on scroll instead (getBoundingClientRect ignores the clip). Boxes that come in together open one after the other. */
  if (rc.length && !reduce) {
    var rcTick = false;
    var rcRun = function () {
      rcTick = false;
      var vh = innerHeight, hits = [];
      rc.forEach(function (e) {
        if (e.__rv) return;
        var r = e.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) hits.push({ e: e, r: r });
      });
      hits.sort(function (a, b) { return (a.r.top - b.r.top) || (a.r.left - b.r.left); });
      hits.forEach(function (h, k) { h.e.style.transitionDelay = (k * 170) + 'ms'; h.e.classList.add('in'); h.e.__rv = 1; });
    };
    addEventListener('scroll', function () { if (!rcTick) { rcTick = true; requestAnimationFrame(rcRun); } }, { passive: true });
    addEventListener('resize', rcRun);
    addEventListener('load', rcRun);
    requestAnimationFrame(function () { requestAnimationFrame(rcRun); });
  } else rc.forEach(function (e) { e.classList.add('in'); });

  /* ---------- motion borrowed from the reference (dropedition.com): GSAP + ScrollTrigger + Lenis ----------
     1. smooth, inertial scroll on every page  2. Garden Hours is pinned while its picture opens up and its words come in
     3. big headings write themselves in, letter by letter, as they come up the screen.
     Nothing here runs with reduced motion or if the libraries did not load: the page is then exactly the plain one. */
  function splitChars(el) {
    var label = el.textContent.replace(/\s+/g, ' ').trim();
    el.setAttribute('aria-label', label);
    el.innerHTML = label.split(' ').map(function (w) {
      return '<span class="wsp" aria-hidden="true">' + w.split('').map(function (c) { return '<span class="csp">' + esc(c) + '</span>'; }).join('') + '</span>';
    }).join(' ');
    return $$('.csp', el);
  }
  if (!reduce && window.gsap && window.ScrollTrigger && window.Lenis) {
    gsap.registerPlugin(ScrollTrigger);
    root.classList.add('gx');

    /* 1. smooth scroll, driven by GSAP's clock so pinned scenes stay in step with it */
    var lenis = new Lenis({
      lerp: 0.1, smoothWheel: true,
      prevent: function (n) { return !!(n.closest && n.closest('[role="dialog"], .dr-panel, .modal, [class^="vs-"], [class*=" vs-"]')); }   /* menus, bag and quick view scroll on their own */
    });
    window.vxLenis = lenis;
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    new MutationObserver(function () {   /* the page behind an open menu or modal must stay still */
      var locked = getComputedStyle(doc.body).overflow === 'hidden';
      if (locked) lenis.stop(); else lenis.start();
    }).observe(doc.body, { attributes: true, attributeFilter: ['style', 'class'] });

    /* ScrollTrigger works out each start/end in the order the triggers are made, and a pin adds space below itself:
       so everything below is created AFTER the Garden Hours pin, everything above before it, i.e. in page order. */
    /* 3. headings: letter by letter, tied to the scroll */
    var headIn = function (sel) {
      var h = $(sel);
      if (!h || h.hasAttribute('data-tight')) return;
      gsap.fromTo(splitChars(h), { opacity: 0, yPercent: 70 }, {
        opacity: 1, yPercent: 0, ease: 'none', stagger: 0.05,
        scrollTrigger: { trigger: h, start: 'top 92%', end: 'top 62%', scrub: 0.6 }
      });
    };
    headIn('.ni-head h3'); headIn('.sets .sec-head h2');

    /* 2. Garden Hours: pinned for a screen and a bit while the picture opens, the film settles and the words arrive (large screens) */
    var edit = $('.edit');
    if (edit) {
      gsap.matchMedia().add('(min-width: 900px)', function () {
        var big = $('.ed-big', edit), film = $('video', big), small = $('.ed-small', edit), copy = $('.ed-copy', edit), h3 = $('h3', copy);
        var rest = $$('p, a', copy);
        [big, small, copy].forEach(function (el) { el.classList.remove('rv', 'rv-card'); el.style.transitionDelay = ''; });   /* GSAP drives these now */
        edit.classList.add('ed-scene');
        var tl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: { trigger: edit, start: 'top top', end: '+=110%', pin: true, scrub: 0.6, anticipatePin: 1 }
        });
        if (film) tl.fromTo(film, { scale: 1.18 }, { scale: 1, duration: 1 }, 0);
        tl.fromTo(small, { clipPath: 'inset(16% 16% 16% 16%)', scale: 0.8 }, { clipPath: 'inset(0% 0% 0% 0%)', scale: 1, duration: 0.6, ease: 'power2.out' }, 0)
          .fromTo(splitChars(h3), { opacity: 0, yPercent: 70 }, { opacity: 1, yPercent: 0, stagger: 0.05, duration: 0.25 }, 0.35)
          .fromTo(rest, { opacity: 0, y: 24 }, { opacity: 1, y: 0, stagger: 0.1, duration: 0.2 }, 0.6);
        return function () { edit.classList.remove('ed-scene'); };
      });
    }
    /* 4. the big statements of "Slow afternoons": every letter opens out by its own random amount and closes up at its own moment
       while you scroll (the reference's way), instead of one blanket letter-spacing. The dark copy and the light copy get identical values. */
    var saEl = $('.sa');
    if (saEl) {
      var wide = innerWidth < 900 ? 0.45 : 1;   /* on a phone the opened-out lines would run far off the screen */
      var saTl = gsap.timeline({ defaults: { ease: 'power2.out' }, scrollTrigger: { trigger: saEl, start: 'top bottom', end: 'bottom bottom', scrub: 0.8 } });
      [['.stmt-s', 0.35, 0.85, 'l'], ['.stmt-b', 0.12, 0.4, 'r']].forEach(function (g, gi) {
        $$('.sa ' + g[0]).forEach(function (el) {
          var chs = $$('.ch', el), fs = parseFloat(getComputedStyle(el).fontSize), box = el.getBoundingClientRect();
          var open = function (i) { return (g[1] + hash(i * 7 + gi * 131 + 1) * g[2]) * wide; };
          /* the lines may open only as far as the screen allows (left text towards the right edge, right text towards the left edge) */
          var room = g[3] === 'l' ? innerWidth * 0.94 - box.left : box.right - innerWidth * 0.04, f = 1;
          $$('.ln', el).forEach(function (ln) {
            var rg = doc.createRange(); rg.selectNodeContents(ln);
            var w0 = rg.getBoundingClientRect().width, sum = 0;
            $$('.ch', ln).forEach(function (c) { sum += open(chs.indexOf(c)) * fs; });
            if (sum > 0) f = Math.min(f, Math.max(0.15, (room - w0) / sum));
          });
          chs.forEach(function (ch, i) {
            saTl.fromTo(ch, { marginRight: (open(i) * f) + 'em' }, { marginRight: '0em', duration: 0.5 }, hash(i * 13 + gi * 71 + 5) * 0.45);
          });
        });
      });
    }
    headIn('.fd-head h3');
    addEventListener('load', function () { ScrollTrigger.refresh(); });
  }
})();
